import { useAuth } from "@/lib/auth";

export default function AcessoNegadoPage() {
  const { user, signOut } = useAuth();

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
      }}
    >
      <div className="card" style={{ width: "min(440px, 100%)" }}>
        <h1>Acesso não autorizado</h1>
        <p>
          {user?.email ?? "Esta conta"} não está na lista de acesso do Admin. Fale com um
          administrador para ser adicionado em <code>app_users</code>.
        </p>
        <button type="button" className="btn btn--secondary" onClick={() => void signOut()}>
          Sair
        </button>
      </div>
    </div>
  );
}
